import React from "react";

interface FormSuccessProps {
  props?: any;
}

const FormSuccess = ({ props }: FormSuccessProps) => {
  return (
    <>
      <div className="flex flex-col items-center justify-center h-screen gap-24 text-center px-4 md:px-0 mt-12 md:mt-0">
        <div className="flex flex-col items-center justify-center gap-4 text-main-gray text-center">
          <div>
            <h1 className="text-black font-bold">
              WE WILL BE GETTING BACK TO YOU WITHIN 24-48 HOURS
            </h1>
          </div>
          <div>
            <p>We appreciate you showing interest in our investments!</p>
            <p>An email has been sent to you with your submission data.</p>
          </div>
          <div>
            <p className="">
              If between{" "}
              <span className="font-bold">9am - 6pm Pacific Time</span>, you may
              call{" "}
              <a
                className="font-bold hover:underline"
                href="tel:8004279898"
                target="_blank"
                rel="noreferrer"
              >
                800-427-9898
              </a>{" "}
              to speak to a member of the Secured Investment Corp Funding Team.
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center gap-4">
          <div>
            <h1 className="text-black font-bold text-2xl">
              MAKE SURE YOU FOLLOW US ON SOCIAL MEDIA! IT'S AS EASY AS 1, 2,
              3...
            </h1>
            <div className="px-4 md:px-48">
              <div className="divider bg-accent h-1"></div>
            </div>
          </div>
          <div className="flex flex-col md:flex-row gap-4 items-center justify-center">
            <div className="flex flex-col columns-1 gap-4 items-center justify-center">
              <div>
                <span className="text-black font-bold">STEP #1</span>
              </div>
              <div className="text-center text-sm text-main-gray w-2/3">
                <span>
                  Join our vibrant community of investors and stay up to date
                  about news and events.
                </span>
              </div>
              <div>
                <a
                  href="https://www.facebook.com/SecuredInvestmentCorp"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-info text-white font-bold"
                >
                  FOLLOW US ON FACEBOOK
                </a>
              </div>
            </div>
            <div className="flex flex-col columns-1 gap-4 items-center justify-center">
              <div>
                <span className="text-black font-bold">STEP #2</span>
              </div>
              <div className="text-center text-sm text-main-gray w-2/3">
                <span>
                  Join our vibrant community of investors and stay up to date
                  about news and events.
                </span>
              </div>
              <div>
                <a
                  href="https://www.instagram.com/securedinvestmentcorp/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-accent btn-md text-white font-bold"
                >
                  FOLLOW US ON INSTAGRAM
                </a>
              </div>
            </div>
            <div className="flex flex-col columns-1 gap-4 items-center justify-center">
              <div>
                <span className="text-black font-bold">STEP #3</span>
              </div>
              <div className="text-center text-sm text-main-gray w-2/3">
                <span>
                  Join our vibrant community of investors and stay up to date
                  about news and events.
                </span>
              </div>
              <div>
                <a
                  href="https://www.linkedin.com/company/secured-investment-corp"
                  target="_blank"
                  rel="noreferrer"
                  className="btn bg-purple-700 hover:bg-purple-800 text-white font-bold"
                >
                  FOLLOW US ON LINKEDIN
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormSuccess;
